module.exports = __webpack_public_path__ + "img/oah-role-enterprise.802c2bb6.svg";